
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IAllRoleInfo} from '@/api/types'
import EmptyState from '@/components/Empty/EmptyState.vue'

@Component({
  components: {
    EmptyState
  }
})
export default class UserRolesCard extends Vue {
  get roles(): IAllRoleInfo[] {
    console.log('UserModule.roles', UserModule.roles)
    return UserModule.roles || []
  }

  // 根据角色ID生成不同的标签类型，使不同角色有不同颜色
  public getTagType(id: number): string {
    const types = ['', 'success', 'warning', 'danger', 'info']
    return types[id % types.length]
  }

  getRoleId(role: IAllRoleInfo): number {
    if (role && role.role) {
      return role.role.id
    }
    return 0
  }

  getRoleName(role: IAllRoleInfo): string {
    if (role && role.role) {
      return role.role.name
    }
    return '-'
  }
}
